<template>
  <div>
    <div v-if="agentUploadErr" style="margin:40px 24px;text-align:center;">
      点击右上角分享至其他浏览器打开页面
    </div>
    <div v-else-if="exceed && isCampusManaQrcode">
      <p class="exceed-text">该二维码已失效，不可投递简历</p>
    </div>
    <div :class="[wrapClass, 'delivery-wrap']" v-else>
      <div v-if="isCampusManaQrcode" class="nav">
        <div :class="`${wrapClass}-logo`"></div>
      </div>
      <a-form :form="form" :class="isCampusManaQrcode ? 'has-nav' : ''">
        <a-form-item label="城市" required>
          <a-select
            @change="handleCityChange"
            placeholder="请选择城市"
            v-decorator="[
              'cityId',
              {
                initialValue: Number($route.query.cId) || undefined,
                rules: [{ required: true, message: '请选择城市' }],
              },
            ]"
          >
            <a-select-option
              v-for="city in cityList"
              :value="city.id"
              :key="city.id"
              >{{ city.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="职位" required>
          <a-select
            showSearch
            placeholder="请选择职位"
            :filterOption="positionFilter"
            :notFoundContent="positionEmpty"
            v-decorator="[
              'positionId',
              {
                initialValue: Number($route.query.pId) || undefined,
                rules: [{ required: true, message: '请选择职位' }],
              },
            ]"
          >
            <a-select-option
              v-for="pos in positionList"
              :value="pos.positionId"
              :key="pos.positionId"
              >{{ pos.positionName }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="上传简历" required>
          <yfd-upload
            @parseSuccess="parseSuccess"
            @change="fileChange"
          ></yfd-upload>
        </a-form-item>
        <a-form-item label="姓名" required>
          <a-input
            placeholder="请输入姓名"
            v-decorator="[
              'name',
              { rules: [{ required: true, message: '请输入姓名' }] },
            ]"
          >
          </a-input>
        </a-form-item>
        <a-form-item label="学校" required>
          <a-input
            placeholder="请输入学校"
            v-decorator="[
              'university',
              { rules: [{ required: true, message: '请输入学校' }] },
            ]"
          >
          </a-input>
        </a-form-item>
        <a-form-item
          label="电话"
          required
          extra="手机号是查询招聘进度的唯一验证方式"
        >
          <a-input
            placeholder="请输入电话"
            v-decorator="[
              'phone',
              { rules: [{ required: true, message: '请输入电话' }] },
            ]"
          >
          </a-input>
        </a-form-item>
        <a-form-item label="邮箱" required>
          <a-input
            placeholder="请输入邮箱"
            v-decorator="[
              'mail',
              { rules: [{ required: true, message: '请输入邮箱' }] },
            ]"
          >
          </a-input>
        </a-form-item>

        <a-form-item
          label="渠道"
          required
          v-if="$route.params.department === 'zebra' && !isCampusManaQrcode"
        >
          <a-select
            v-decorator="[
              'channel',
              {
                rules: [{ required: true, message: '请选择渠道' }],
              },
            ]"
            placeholder="请选择渠道"
          >
            <a-select-option value="社招">
              社招
            </a-select-option>
            <a-select-option value="校招">
              校招
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
      <a-button class="submit" @click="submit">提交简历</a-button>
      <feedback :deparment="$route.params.department">
        <div>
          <a-button
            class="go-progress"
            @click="goProgressPage"
            v-if="deliveryStatus === 'duplicate' && department === '猿辅导'"
          >
            查看我的投递进度
          </a-button>
        </div>
        <div
          class="go-progress-zebra"
          @click="goProgressPage"
          v-if="deliveryStatus === 'duplicate' && department === '斑马'"
        >
          <span>查看我的投递进度</span>
          <img src="../../../public/img/right-zebra.png" alt="" />
        </div>

        <p
          class="sub-content"
          v-if="deliveryStatus === 'success' && department === '猿辅导'"
        >
          可点击首页右上角
          <a-icon type="user" style="color:#222" /> 查看投递进度
        </p>
      </feedback>
    </div>
  </div>
</template>
<script>
import {
  getDeptCity,
  getDeptPositionNew,
  uploadTutorResume,
  schoolUploadResume,
  checkQrCodeStatus,
} from '@/service/resume'
import { YfdUpload } from '@/components/Upload'
import Feedback from '@/components/Feedback'
import { routerNamePrefix } from './router'

export default {
  components: { YfdUpload, Feedback },
  data() {
    return {
      exceed: false,
      cityList: [],
      positionList: [],
      department: '猿辅导',
      form: this.$form.createForm(this),
      positionEmpty: '请先选择城市',
      file: null,
      deliveryStatus: 'waiting', // 投递结果
    }
  },
  computed: {
    wrapClass() {
      // 区分不同产品线主题色
      return `delivery-${this.$route.params.department}`
    },
    keyfrom() {
      return this.$store.state.official.keyfrom
    },
    agentUploadErr() {
      return this.$store.state.agentUploadErr
    },
    isCampusManaQrcode() {
      const { id } = this.$route.query
      return !!id
    },
  },
  watch: {
    '$route.params.department': {
      handler: 'departmentHandler',
      immediate: true,
    },
  },
  async created() {
    await this.checkQrCodeStatus()
    await this.getCity()
    if (this.$route.query.cId) {
      this.queryPosition(this.$route.query.cId)
    }
    const { keyfrom } = this.$route.query
    keyfrom && this.$store.commit('official/setKeyfrom', keyfrom)
  },
  mounted() {
    this.frogReport('/event/mRecurimentDelivery/pageView')
  },
  methods: {
    async checkQrCodeStatus() {
      if (!this.isCampusManaQrcode) return
      const { id, sc } = this.$route.query
      if (id && isNaN(sc)) {
        return (this.exceed = true)
      }
      const query = {
        id,
        secChannelId: Number(sc),
      }
      this.exceed = await checkQrCodeStatus(query)
    },
    async getCity() {
      this.cityList = await getDeptCity({ depart: this.department })
    },
    async queryPosition(cityId) {
      const query = {
        cityId,
        recruitmentWebsiteId: this.department === '猿辅导' ? 1 : 2,
        flag: 0,
        type: '',
        teachType: '11',
        positionName: '',
      }
      this.positionList = await getDeptPositionNew(query)
    },
    handleCityChange(cityId) {
      this.form.setFieldsValue({ positionId: undefined })
      this.form.validateFields(['positionId'], () => {})
      this.positionList = []
      this.queryPosition(cityId)
    },
    positionFilter(input, option) {
      const filtered =
        option.componentOptions.children[0].text.indexOf(input) >= 0
      if (!filtered.length) {
        this.positionEmpty = '未找到匹配项'
      }
      return filtered
    },
    departmentHandler(department) {
      switch (department) {
        case 'tutor':
          this.department = '猿辅导'
          break
        case 'zebra':
          this.department = '斑马'
          break
        default:
          this.department = '猿辅导'
          break
      }
      this.$store.commit('official/setDepartment', department)
    },
    parseSuccess(candidateInfo) {
      this.candidateInfo = candidateInfo
      const { name, phone, mail, educations } = candidateInfo
      this.form.setFieldsValue({ name, phone, mail })
      educations[0] &&
        educations[0].university &&
        this.form.setFieldsValue({ university: educations[0].university })
    },
    async submit() {
      this.frogReport('/click/mRecurimentDelivery/submit')
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          if (this.file) {
            const formData = this.getFormData(values)
            this.submitRequest(formData)
          } else {
            this.$toast('请上传简历')
          }
        }
      })
    },
    async submitRequest(body) {
      try {
        let res = this.isCampusManaQrcode
          ? await schoolUploadResume({ body })
          : await uploadTutorResume({ body })
        if (res.code === 1) {
          if (this.isCampusManaQrcode) {
            this.$router.push({
              path: `/official/delivery/${
                this.$route.params.department
              }/success`,
            })
            return
          }
          this.$bus.$emit('feedbackModal', {
            status: 'success',
            title: '提交成功',
            content: '如果通过简历筛选，HR会在1-3个工作日联系你。',
          })
          this.deliveryStatus = 'success'
          this.frogReport('/event/mRecurimentDelivery/Success', [
            { key: 'SRId', value: res.data[0] },
          ])
        } else {
          if (this.isCampusManaQrcode) {
            if (res.msg.includes('您已在该渠道投递过该职位')) {
              this.$router.push({
                path: `/official/delivery/${
                  this.$route.params.department
                }/fail`,
              })
            } else {
              this.deliveryStatus = 'error'
              this.submitError(res.msg)
            }
            return
          }
          // 简历重复
          this.deliveryStatus = 'error'
          if (res.msg.includes('你已通过本渠道投递过本职位，不得多次提交')) {
            this.submitError(
              '如果通过简历筛选，HR会在1-3个工作日联系你。',
              '你已投递过该职位',
            )
            this.deliveryStatus = 'duplicate'
            this.frogReport('/event/mRecurimentDelivery/Duplicate')
          } else {
            this.submitError(res.msg)
          }
        }
      } catch {
        // this.submitError('系统失败，请重试')
        // this.deliveryStatus = 'error'
      }
    },
    submitError(message, title = '投递失败') {
      this.$bus.$emit('feedbackModal', {
        status: 'error',
        title,
        content: message,
      })
    },
    getFormData(values) {
      let formData = new FormData()
      const { name, phone, mail, university, channel = '社招' } = values
      const { cl, sc, cd } = this.$route.query
      const channelJson = {
        channel: cl || channel,
        secChannelId: Number(sc) || 9,
        desc: cd || this.keyfrom,
        uploaderLdap: '',
      }
      let resumeJson = { ...this.candidateInfo, name, phone, mail }
      if (resumeJson.educations[0]) {
        resumeJson.educations[0].university = university
      } else {
        resumeJson.educations[0] = { university }
      }
      formData.append('files', this.file)
      formData.append('resumeJson', JSON.stringify(resumeJson))
      formData.append('positionIds', [values.positionId])
      formData.append('channelJson', JSON.stringify(channelJson))
      return formData
    },
    goProgressPage() {
      this.frogReport('/click/mRecurimentDelivery/toMyProgress')
      this.$router.push({
        name: `${routerNamePrefix}_myProgress`,
        params: this.$route.params,
        query: this.$route.query,
      })
    },
    fileChange(file) {
      this.file = file
    },
    frogReport(url, extra = []) {
      this.$addFrog(1531, url, [
        { key: 'keyfrom', value: this.keyfrom },
        ...extra,
      ])
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@style/common.less';
.delivery-wrap {
  margin: 0 auto;
  padding: 0 15px 48px;
  max-width: 750px;
  height: 100vh;
  overflow: auto;
  .submit {
    width: 100%;
    height: 48px;
    font-size: 18px;
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: 0;
    background: @tutor-color;
    color: #fff;
    &:hover,
    &:focus {
      border: none;
    }
  }
  .go-progress {
    border-color: @tutor-color;
    border-radius: 0;
    color: @tutor-color;
  }
  .sub-content {
    font-size: 11px;
    color: #8c8c8c;
    line-height: 26px;
    padding: 0 16px;
  }
  &.delivery-zebra {
    .submit {
      background: @zebra-color;
    }
    .go-progress-zebra {
      margin-top: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        color: #34c83f;
        font-size: 14px;
        margin-right: 4px;
        line-height: 20px;
      }
      img {
        width: 12px;
      }
    }
    .yfd-upload-wrap > div .yfd-upload .yfd-upload-button {
      color: @zebra-color;
    }
  }
}
.exceed-text {
  text-align: center;
  font-size: 0.16rem;
  padding-top: 0.8rem;
}
</style>
<style lang="less">
@import '~@style/common.less';
.delivery-wrap {
  .nav {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 0.44rem;
    background-color: #fff;
    display: flex;
    align-items: center;
    z-index: 2;
    .delivery-zebra-logo,
    .delivery-tutor-logo {
      margin-left: 0.15rem;
      width: 0.9rem;
      height: 0.2rem;
      background-repeat: no-repeat;
      background-size: contain;
    }
    .delivery-zebra-logo {
      background-image: url('../../../public/img/logo-banma.png');
    }
    .delivery-tutor-logo {
      background-image: url('../../../public/img/logo.png');
    }
  }
  .has-nav {
    padding-top: 0.44rem;
  }
  .ant-form {
    .ant-form-item {
      .ant-form-item-label {
        color: #333;
        font-size: 14px;
        line-height: 16px;
        padding-bottom: 16px;
      }
    }
    .ant-form-item-required::before {
      color: @tutor-color;
    }
    .ant-select-selection,
    .ant-input {
      border-radius: 0;
    }
    .ant-select-selection--single,
    .ant-input {
      height: 36px;
    }
    .ant-select-selection__rendered,
    .ant-input {
      line-height: 34px;
    }
    .has-error .ant-input,
    .has-error .ant-input:hover,
    .has-error .ant-select-selection {
      border-color: @tutor-color;
    }
    .has-error .ant-form-explain,
    .has-error .ant-form-split {
      color: @tutor-color;
    }
  }
}
</style>
